import APIController from '../core-api-controller';

export const fetchGmailEmails = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/support/gmails/messages${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const modifyMessagesApi = (data = {}) => {
  const path = `${APIController.endpointApi}/support/gmails/modify_messages`;
  return APIController.postCallback(path, data);
};

export const fetchGmailAttachment = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/support/gmails/fetch_attachment${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const getThreadApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/support/gmails/fetch_thread_messages${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const sendEmailApi = (data = {}) => {
  const path = `${APIController.endpointApi}/support/gmails/send_message`;
  return APIController.postCallback(path, data);
};
